import React, { Component } from 'react';

import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import { DocumentTitle } from '@hsp/react-component-library';

import ClientGroupTable from '@p/security/users/client-group/components/table/table.component';

import { t } from '@u/strings';

class ClientGroupPage extends Component {
  render() {
    return (
      <React.Fragment>
        <DocumentTitle title={t('Site.Client')} />
        <div className="page-content">
          <Container fluid>
            <Row className=" mb-4">
              <Col
                md={6}
                sm={12}
                xl={7}>
                <h4>Client Groups</h4>
              </Col>
              {/* <Col
                className="d-flex justify-content-md-end justify-content-between"
                sm={12}
                xl={5}
                md={6}>
                <IconButton
                  color="outline-primary"
                  icon={'reply'}>
                  {s(['Site.User', 'Site.Dashboard'])}
                </IconButton>
              </Col> */}
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <ClientGroupTable />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default ClientGroupPage;
